export default __webpack_public_path__ + "img/fozBGdSf.e051a48e.svg";